<div [formGroup]="form"
     class="flex-col gap-16 form">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.MOBILE_PUSH.LABELS.SELECT_ORG_USERS'|translate }}</label>

        <org-users-select formControlName="orgUserIds" [required]="true"></org-users-select>
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.MOBILE_PUSH.TITLE'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="title">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.MOBILE_PUSH.BODY'|translate }} <span class="required">*</span></label>

        <ui-text-area-variables formControlName="body"
                                [options]="selectVariablesAutoComplete">
        </ui-text-area-variables>
    </div>
</div>